import type { BuyerCart, CartTarget } from './CartLines';

export function cartFor(carts: BuyerCart[], target: CartTarget) {
  return carts.find(
    (cart) =>
      cart.sellerOrganizationFacility.id === target.facilityId &&
      cart.shippingLocation.id === target.locationId &&
      !cart.parentOrder &&
      !cart.isFromQuote
  );
}
